var slick = require("slick-slider");
var Equalizer = require("equalizer");
var PubSub = require("underpub-js");

var iconItemSlider = function(options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);
};

iconItemSlider.prototype.init = function() {
  var self = this;

  self.$slider = this.options.$el.find(".icon-item-slider");
  self.$prevArrow = this.options.$el.find(".slider-navigation-arrows .prev");
  self.$nextArrow = this.options.$el.find(".slider-navigation-arrows .next");

  console.log(self.$prevArrow);

  // init the slider
  self.$slider.slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: self.$prevArrow,
    nextArrow: self.$nextArrow,
    responsive: [
      {
        breakpoint: 1200, // large down
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 800, // medium down
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // small down
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
};

module.exports = iconItemSlider;
